import { useCallback, useState } from 'react';

import Description from '@mui/icons-material/Description';
import Launch from '@mui/icons-material/Launch';
import { IconButton, Link } from '@mui/material';

import { formatOfferingDocumentType, openPdf } from '@arrived/common';
import { OfferingDocument, OfferingDocumentFormat } from '@arrived/models';
import { useGetOfferingDocumentRawQuery } from '@arrived/queries';

import { LoadingBackdrop } from '../../../LoadingBackdrop';
import { PropertyDetailsListItem } from '../PropertyDetailsList';

interface AnonymousDocumentProps {
  document: OfferingDocument;
}

const AnonymousDocument = ({ document }: AnonymousDocumentProps) => {
  const [enabled, setEnabled] = useState(false);
  const documentRawState = useGetOfferingDocumentRawQuery(document.id, {
    enabled,
    onSuccess: (data) => openPdf(data),
  });

  const handleOnClick = useCallback(() => {
    setEnabled(true);
    if (documentRawState.isSuccess) {
      openPdf(documentRawState.data);
    }
  }, [documentRawState.isSuccess, documentRawState.data]);

  const renderDocument = useCallback(() => {
    switch (document.format) {
      case OfferingDocumentFormat.PDF:
        return (
          <IconButton onClick={handleOnClick}>
            <Description color="primary" />
          </IconButton>
        );
      case OfferingDocumentFormat.URL:
        return (
          <Link href={document.fileUrl} target="_blank">
            <IconButton>
              <Launch color="primary" />
            </IconButton>
          </Link>
        );
    }
  }, [document, handleOnClick]);

  return (
    <>
      {renderDocument()}
      <LoadingBackdrop open={documentRawState.isFetching} />
    </>
  );
};

export const documentsConfig = (documents: OfferingDocument[]): PropertyDetailsListItem[] =>
  documents.map((document) => ({
    label: formatOfferingDocumentType(document.type),
    value: <AnonymousDocument document={document} />,
  }));
